<template>
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-8">
                <form @submit.prevent="onUpdateForm">
                    <h3 class="text-center">Редактиране на {{ service.name }}</h3>
                    <div class="form-group">
                        <label>Снимка</label>
                        <img class="d-block img" :src="service.image" alt="">
                    </div>
                    <div class="form-group">
                        <label>Име</label>
                        <input type="text" class="form-control" v-model="service.name" required>
                    </div>
                    <div class="form-group">
                        <label>Описание</label>
                        <div class="editor-wrapper">
                            <vue-editor v-model="service.description" required></vue-editor>
                        </div>
                    </div>

                    <div class="form-group">
                        <button class="btn btn-primary btn-block">Запази</button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
    import { db } from '../../firebase';
    import { VueEditor } from "vue2-editor";

    export default {
        components: {
            VueEditor
        },
        data() {
            return {
                service: {
                }
            }
        },
        created() {
            let dbRef = db.collection('services').doc(this.$route.params.id);
            dbRef.get().then((doc) => {
                this.service = doc.data();
            }).catch((error) => {
                console.log(error)
            })
        },
        methods: {
            onUpdateForm(event) {
                event.preventDefault();
                db.collection('services').doc(this.$route.params.id)
                    .update(this.service).then(() => {
                    console.log("Успешно обновихте услугата!");
                    this.$router.push('/services')
                }).catch((error) => {
                    console.log(error);
                });
            }
        }
    }
</script>
